import ScheduledBillSearchPage from "./ScheduledBillSearchPage";

export default ScheduledBillSearchPage;
